import { gql } from "@apollo/client";

export const bookingDeleteMutation = gql`
  mutation($scenarioId: ID!, $originId: ID!, $input: ClassroomBookingChangeStatusInput) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomBookingChangeStatus(input: $input) {
        skippedValidations
        commited
        validationErrors {
          __typename
          ... on ClassroomClash {
            sessions {
              id
            }
          }
        }
      }
    }
  }
`;
